import React from 'react';
import PropTypes from 'prop-types';

// Inline red error list rendered under a form field. Default in the signature, not via
// defaultProps — React 19 ignores defaultProps on function components and warns on
// every mount (same reason as ColorRow/Toggle in ColorsTab and RatioSlider in LogoTab).
export default function FieldErrors({ messages = null }) {
  if (!messages || messages.length === 0) return null;
  return (
    <ul className="qr-field-errors" role="alert">
      {messages.map((m) => <li key={m}>{m}</li>)}
    </ul>
  );
}

FieldErrors.propTypes = { messages: PropTypes.arrayOf(PropTypes.string) };

// The wrapper class for a field whose control should show the invalid outline. Lives
// beside FieldErrors because the two are always used as a pair -- the wrapper marks
// the control, the list carries the message -- and every call site named the same key
// twice. Takes several keys for the one field (Dot fill) whose control is invalid on
// either of two errors. `extra` carries a co-occurring layout class.
//
// `has-error` is Bootstrap's, not ours, and is deliberate: _custom.scss:316 names the
// project's canonical error UX as a red .form-control border plus a message, and the
// theme already implements it -- including the select2 wrapper (_custom.scss:343),
// which a bespoke `.form-control` rule cannot reach because select2 hides the real
// <select> and paints .select2-selection--single instead. Riding the existing cascade
// is what makes the two Select2-backed fields (Logo shape, Default download size)
// outline at all. Nothing else in this form leaks: Bootstrap's has-error cascade keys
// off .help-block/.control-label/.checkbox, and the form uses .qr-help/.qr-label/
// .qr-check-row.
export function fieldClass(errors, keys, extra = '') {
  const invalid = [].concat(keys).some((key) => errors[key]);
  return `qr-field${extra ? ` ${extra}` : ''}${invalid ? ' has-error' : ''}`;
}
